import {Hotel} from './types';

const hotels: Array<Hotel> = [
  {
    id: 1,
    isActive:true,
    ownerId:1,
    name: 'EA Zámecký Hotel Hrubá Skála',
    category: '****',
    destination: 'Turnov , Liberecký kraj',
    price: 4980,
    slug: 'ea-zamecky-hotel-hruba-skala',
    published_at: '2020-11-13T08:53:32.188Z',
    created_at: '2020-11-13T07:47:56.126Z',
    updated_at: '2020-12-10T15:01:58.726Z',
    ratting: {cleanliness: 5, comfort: 5, staf: 5, facilities: 5, locality: 5, priceValue: 5, total: 5, numberOfRattings:5 },
    address: {
      street: 'Hrubá Skála 1',
      city: 'Turnov',
      postalCode: '511 01',
      longitude: 15.19318,
      latitude: 50.54488, 
    },
    roomTypes:[
      {id:10, name:'Dvoulůžkový pokoj', numberOfPax:2,numberOfExtrabed:0,numberOfChildExtrabed:0},
      {id:20, name:'Dvoulůžkový pokoj s přistýlkou', numberOfPax:2,numberOfExtrabed:1,numberOfChildExtrabed:0},
      {id:33, name:'Rodinný pokoj', numberOfPax:4,numberOfExtrabed:0,numberOfChildExtrabed:0}
    ],
    cmsData: {
      shortDescription:
        'Chcete prožít **pohádkovou dovolenou na zámku?** Máte rádi **romantiku a luxus?** Tohle vše a ještě mnohem víc Vám nabízí **EA Zámecký hotel Hrubá Skála******. Zámecký hotel Hrubá Skála je stylový čtyřhvězdičkový hotel, který Vás nadchne ubytováním v krásných zámeckých pokojích.',
      longDescription:
        'Chcete prožít pohádkovou dovolenou na zámku? Máte rádi romantiku a luxus? Tohle vše a ještě mnohem víc Vám nabízí **EA Zámecký hotel Hrubá Skála******. Zámecký hotel Hrubá Skála je stylový čtyřhvězdičkový hotel, který Vás nadchne ubytováním v krásných zámeckých pokojích.\n\n![11000.jpg](http://localhost:1337/uploads/11000_f601807f81.jpg)\n\nOchutnat můžete široký výběr místních i mezinárodních jídel v několika zámeckých restauracích. Na druhém nádvoří se nachází Zámecká restaurace, na hradbách pak doporučujeme navštívit Letní vyhlídkovou restauraci. Pro milovníky historie je připravena Středověká krčma a Lovecký salonek. Bohaté snídaně jsou podávány formou švédského stolu ve Valdštejnském sále, kde na Vás dýchne úžasná atmosféra.\n\n![16000.jpg](http://localhost:1337/uploads/16000_1e4bbbc1a6.jpg)\n\nZámecký hotel Hrubá Skála disponuje také vlastním **wellness centrem**, kde si můžete dopřát skvělé masáže, zábaly či kosmetická ošetření. Vaše tělo i mysl osvěží báječné koupele i optimální kombinace procedur, které v sobě spojují to nejlepší z nabídky Rajských lázní. Rajské lázně, nebo-li také Eden Spa, jsou unikátním wellness centrem, které je Vám k dispozici od července 2014. Odpočiňte si při báječné relaxaci v panoramatické sauně, parní lázni nebo v tureckých lázních Hamam. Vaše unavené tělo se zregeneruje, očistí a uvolní při koupelích a celotělových lázeňských procedurách.\n\n![13000.jpg](http://localhost:1337/uploads/13000_fc88327964.jpg)\n\nSoučástí Rajských lázní je parní komora a panoramatická sauna, ze které se Vám naskytne dech beroucí výhled na skalní město. Z lázní je přímý vstup na venkovní odpočívadlo, kde se na terase můžete osvěžit a kochat se pohledem na krajinu Českého ráje. Relaxovat s Vámi mohou i Vaše děti, pro které je připravena neodolatelně voňavá čokoládová masáž.\n\n<iframe width="610" height="343" style="max-width: 100%;" src="https://www.youtube.com/embed/hzCgCE_R5Jc" frameborder="0" allowfullscreen=""></iframe>\n',
      images: [
        {
          id: 9,
          name: '11000.jpg',
          alternativeText: '',
          caption: '',
          width: 940,
          height: 625,
          formats: {
            thumbnail: {
              name: 'thumbnail_11000.jpg',
              hash: 'thumbnail_11000_f601807f81',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 235,
              height: 156,
              size: 10.5,
              path: null,
              url: '/uploads/thumbnail_11000_f601807f81.jpg',
            },
            medium: {
              name: 'medium_11000.jpg',
              hash: 'medium_11000_f601807f81',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 499,
              size: 93.57,
              path: null,
              url: '/uploads/medium_11000_f601807f81.jpg',
            },
            small: {
              name: 'small_11000.jpg',
              hash: 'small_11000_f601807f81',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 332,
              size: 44.81,
              path: null,
              url: '/uploads/small_11000_f601807f81.jpg',
            },
          },
          hash: '11000_f601807f81',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 128.71,
          url: '/uploads/11000_f601807f81.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-13T08:31:59.876Z',
          updated_at: '2020-11-13T08:31:59.903Z',
        },
        {
          id: 16,
          name: '16000.jpg',
          alternativeText: '',
          caption: '',
          width: 940,
          height: 625,
          formats: {
            thumbnail: {
              name: 'thumbnail_16000.jpg',
              hash: 'thumbnail_16000_e7ce65e45b',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 235,
              height: 156,
              size: 11.21,
              path: null,
              url: '/uploads/thumbnail_16000_e7ce65e45b.jpg',
            },
            medium: {
              name: 'medium_16000.jpg',
              hash: 'medium_16000_e7ce65e45b',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 499,
              size: 89.27,
              path: null,
              url: '/uploads/medium_16000_e7ce65e45b.jpg',
            },
            small: {
              name: 'small_16000.jpg',
              hash: 'small_16000_e7ce65e45b',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 332,
              size: 43.71,
              path: null,
              url: '/uploads/small_16000_e7ce65e45b.jpg',
            },
          },
          hash: '16000_e7ce65e45b',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 128.29,
          url: '/uploads/16000_e7ce65e45b.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-13T08:32:02.431Z',
          updated_at: '2020-11-13T08:32:02.457Z',
        },
        {
          id: 10,
          name: '12000.jpg',
          alternativeText: '',
          caption: '',
          width: 940,
          height: 625,
          formats: {
            thumbnail: {
              name: 'thumbnail_12000.jpg',
              hash: 'thumbnail_12000_98e073c6f3',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 235,
              height: 156,
              size: 11.12,
              path: null,
              url: '/uploads/thumbnail_12000_98e073c6f3.jpg',
            },
            medium: {
              name: 'medium_12000.jpg',
              hash: 'medium_12000_98e073c6f3',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 499,
              size: 96.73,
              path: null,
              url: '/uploads/medium_12000_98e073c6f3.jpg',
            },
            small: {
              name: 'small_12000.jpg',
              hash: 'small_12000_98e073c6f3',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 332,
              size: 46.52,
              path: null,
              url: '/uploads/small_12000_98e073c6f3.jpg',
            },
          },
          hash: '12000_98e073c6f3',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 132.84,
          url: '/uploads/12000_98e073c6f3.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-13T08:32:00.763Z',
          updated_at: '2020-11-13T08:32:00.858Z',
        },
        {
          id: 13,
          name: '13000.jpg',
          alternativeText: '',
          caption: '',
          width: 939,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_13000.jpg',
              hash: 'thumbnail_13000_921137d4fb',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 9.62,
              path: null,
              url: '/uploads/thumbnail_13000_921137d4fb.jpg',
            },
            medium: {
              name: 'medium_13000.jpg',
              hash: 'medium_13000_921137d4fb',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 500,
              size: 81.38,
              path: null,
              url: '/uploads/medium_13000_921137d4fb.jpg',
            },
            small: {
              name: 'small_13000.jpg',
              hash: 'small_13000_921137d4fb',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 333,
              size: 38.45,
              path: null,
              url: '/uploads/small_13000_921137d4fb.jpg',
            },
          },
          hash: '13000_921137d4fb',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 122.27,
          url: '/uploads/13000_921137d4fb.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-13T08:32:01.582Z',
          updated_at: '2020-11-13T08:32:01.619Z',
        },
        {
          id: 14,
          name: '14000.jpg',
          alternativeText: '',
          caption: '',
          width: 939,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_14000.jpg',
              hash: 'thumbnail_14000_61ff37046b',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 12.9,
              path: null,
              url: '/uploads/thumbnail_14000_61ff37046b.jpg',
            },
            medium: {
              name: 'medium_14000.jpg',
              hash: 'medium_14000_61ff37046b',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 500,
              size: 111.51,
              path: null,
              url: '/uploads/medium_14000_61ff37046b.jpg',
            },
            small: {
              name: 'small_14000.jpg',
              hash: 'small_14000_61ff37046b',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 333,
              size: 53.82,
              path: null,
              url: '/uploads/small_14000_61ff37046b.jpg',
            },
          },
          hash: '14000_61ff37046b',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 146.83,
          url: '/uploads/14000_61ff37046b.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-13T08:32:01.844Z',
          updated_at: '2020-11-13T08:32:01.876Z',
        },
        {
          id: 11,
          name: '12010.jpg',
          alternativeText: '',
          caption: '',
          width: 939,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_12010.jpg',
              hash: 'thumbnail_12010_55196bdddc',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 7.75,
              path: null,
              url: '/uploads/thumbnail_12010_55196bdddc.jpg',
            },
            medium: {
              name: 'medium_12010.jpg',
              hash: 'medium_12010_55196bdddc',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 500,
              size: 57.2,
              path: null,
              url: '/uploads/medium_12010_55196bdddc.jpg',
            },
            small: {
              name: 'small_12010.jpg',
              hash: 'small_12010_55196bdddc',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 333,
              size: 28.3,
              path: null,
              url: '/uploads/small_12010_55196bdddc.jpg',
            },
          },
          hash: '12010_55196bdddc',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 86.15,
          url: '/uploads/12010_55196bdddc.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-13T08:32:01.099Z',
          updated_at: '2020-11-13T08:32:01.141Z',
        },
        {
          id: 12,
          name: '12200.jpg',
          alternativeText: '',
          caption: '',
          width: 939,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_12200.jpg',
              hash: 'thumbnail_12200_95bf15a91a',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 13.54,
              path: null,
              url: '/uploads/thumbnail_12200_95bf15a91a.jpg',
            },
            medium: {
              name: 'medium_12200.jpg',
              hash: 'medium_12200_95bf15a91a',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 500,
              size: 110.08,
              path: null,
              url: '/uploads/medium_12200_95bf15a91a.jpg',
            },
            small: {
              name: 'small_12200.jpg',
              hash: 'small_12200_95bf15a91a',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 333,
              size: 54.18,
              path: null,
              url: '/uploads/small_12200_95bf15a91a.jpg',
            },
          },
          hash: '12200_95bf15a91a',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 153.78,
          url: '/uploads/12200_95bf15a91a.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-13T08:32:01.314Z',
          updated_at: '2020-11-13T08:32:01.381Z',
        },
        {
          id: 15,
          name: '15000.jpg',
          alternativeText: '',
          caption: '',
          width: 939,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_15000.jpg',
              hash: 'thumbnail_15000_8ab7f8e4d0',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 11.08,
              path: null,
              url: '/uploads/thumbnail_15000_8ab7f8e4d0.jpg',
            },
            medium: {
              name: 'medium_15000.jpg',
              hash: 'medium_15000_8ab7f8e4d0',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 500,
              size: 96.34,
              path: null,
              url: '/uploads/medium_15000_8ab7f8e4d0.jpg',
            },
            small: {
              name: 'small_15000.jpg',
              hash: 'small_15000_8ab7f8e4d0',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 333,
              size: 46.21,
              path: null,
              url: '/uploads/small_15000_8ab7f8e4d0.jpg',
            },
          },
          hash: '15000_8ab7f8e4d0',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 137.7,
          url: '/uploads/15000_8ab7f8e4d0.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-13T08:32:02.047Z',
          updated_at: '2020-11-13T08:32:02.082Z',
        },
      ],
    },
    packages: [
      {
        id: 5,
        name: 'Zamilovaní v Ráji - 2 noci pro dva na Zámku Hrubá Skála',
        slug: 'zamilovani-v-raji',
        priceFrom: 4980,
        priceTo: 5480,
        minNumberOfPax: 2,
        minNumberOfDays: 3,
        minNumberOfNights: 2,
        maxNumberOfPax: 2,
        maxNumberOfDays: 3,
        maxNumberOfNights: 2,
        cmsData: {
          id: 3,
          image: {
            id: 9,
            name: '11000.jpg',
            alternativeText: '',
            caption: '',
            width: 940,
            height: 625,
            formats: {
              thumbnail: {
                name: 'thumbnail_11000.jpg',
                hash: 'thumbnail_11000_f601807f81',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 235,
                height: 156,
                size: 10.5,
                path: null,
                url: '/uploads/thumbnail_11000_f601807f81.jpg',
              },
              medium: {
                name: 'medium_11000.jpg',
                hash: 'medium_11000_f601807f81',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 499,
                size: 93.57,
                path: null,
                url: '/uploads/medium_11000_f601807f81.jpg',
              },
              small: {
                name: 'small_11000.jpg',
                hash: 'small_11000_f601807f81',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 332,
                size: 44.81,
                path: null,
                url: '/uploads/small_11000_f601807f81.jpg',
              },
            },
            hash: '11000_f601807f81',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 128.71,
            url: '/uploads/11000_f601807f81.jpg',
            previewUrl: null,
            provider: 'local',
            provider_metadata: null,
            created_at: '2020-11-13T08:31:59.876Z',
            updated_at: '2020-11-13T08:31:59.903Z',
          },
        },
        variants: [
          {
            id: 6,
            name: '3denní romantika - Zamilovaní v Ráji',
            numberOfPax: 2,
            numberOfExtraBed: 0,
            numberOfFreeChild: 0,
            numberOfNights: 2,
            content:
              '<ul>\n<li>Ubytování na 2 noci ve dvoulůžkovém pokoji pro dvě osoby</li>\n<li>2x <strong>snídaně</strong> formou bufetu pro 2 osoby</li>\n<li>1x<strong> slavnostní večeře</strong> pro dva</li>\n<li>1x <strong>tříchodová večeře</strong> pro 2 osoby</li>\n<li>1x <strong>1 hodina v&nbsp;Eden Spa</strong> pro dva&nbsp;(pára, sauna, relaxační prostor s vyhlídkou do Skalního města. <strong>Nejedná se o privátní wellness, v&nbsp;Eden Spa budete s&nbsp;ostatními klienty</strong>)</li>\n<li>1x <strong>čokoládová masáž zad</strong> (25 min.) pro&nbsp;oba</li>\n<li>1x vstup na vyhlídkovou věž zámku Hrubá Skála pro 2 osoby</li>\n</ul>',
            note: 'Při příjezdu je účtován rekreační a ubytovací poplatek obci 20 Kč za osobu na den, děti do 18 let a držitelé průkazu ZTP bez poplatku obci.',
            description:
              '<p>Prožijte jedinečnou dovolenou &nbsp;plnou romantických zážitků, odpočinku v&nbsp;lázních a výletů do krásné přírody <strong>Českého ráje</strong>. Bydlet budete v&nbsp;nádherných zámeckých pokojích a v&nbsp;Rajských lázních si dopřejete příjemnou relaxaci s&nbsp;čokoládovou masáží. Slavnostní večeře bude skvělou tečkou za tímto mimořádným pobytem. Rádi vás uvítáme v&nbsp;<strong>EA Zámeckém hotelu Hrubá Skála****.</strong></p>',
            termValidityFrom: '2020-11-16',
            termValidityTo: '2021-10-14',
            priceFrom: 4980,
            priceTo: 4980,
          },
          {
            id: 17,
            name: '4denní romantika - Zamilovaní v Ráji',
            numberOfPax: 2,
            numberOfExtraBed: 0,
            numberOfFreeChild: 0,
            numberOfNights: 3,
            content:
              '<ul>\n<li>Ubytování na 3 noci ve dvoulůžkovém pokoji pro dvě osoby</li>\n<li>3x <strong>snídaně</strong> formou bufetu pro 2 osoby</li>\n<li>1x<strong> slavnostní večeře</strong> pro dva</li>\n<li>2x <strong>tříchodová večeře</strong> pro 2 osoby</li>\n<li>1x <strong>1 hodina v&nbsp;Eden Spa</strong> pro dva&nbsp;(pára, sauna, relaxační prostor s vyhlídkou do Skalního města. <strong>Nejedná se o privátní wellness, v&nbsp;Eden Spa budete s&nbsp;ostatními klienty</strong>)</li>\n<li>1x <strong>čokoládová masáž zad</strong> (25 min.) pro&nbsp;oba</li>\n<li>1x vstup na vyhlídkovou věž zámku Hrubá Skála pro 2 osoby</li>\n</ul>',
            note: ' Při příjezdu je účtován rekreační a ubytovací poplatek obci 20 Kč za osobu na den, děti do 18 let a držitelé průkazu ZTP bez poplatku obci.',
            description:
              '<p>Prožijte jedinečnou dovolenou &nbsp;plnou romantických zážitků, odpočinku v&nbsp;lázních a výletů do krásné přírody <strong>Českého ráje</strong>. Bydlet budete v&nbsp;nádherných zámeckých pokojích a v&nbsp;Rajských lázních si dopřejete příjemnou relaxaci s&nbsp;čokoládovou masáží. Slavnostní večeře bude skvělou tečkou za tímto mimořádným pobytem. Rádi vás uvítáme v&nbsp;<strong>EA Zámeckém hotelu Hrubá Skála****.</strong></p>',
            termValidityFrom: '2020-11-16',
            termValidityTo: '2021-07-16',
            priceFrom: 5480,
            priceTo: 5480,
          },
        ],
        categories: [
          {
            id: 1,
            name: 'Wellness pobyty',
            slug: 'wellness-pobyty',
            position: 1,
            published_at: '2020-12-10T14:26:35.659Z',
            created_at: '2020-12-10T14:26:33.470Z',
            updated_at: '2020-12-13T12:33:33.807Z',
          },
          {
            id: 2,
            name: 'Zámecké pobyty',
            slug: 'zamecke-pobyty',
            position: 2,
            published_at: '2020-12-10T14:26:59.517Z',
            created_at: '2020-12-10T14:26:57.011Z',
            updated_at: '2020-12-13T12:33:59.208Z',
          },
          {
            id: 3,
            name: 'Pobyty pro dva',
            slug: 'pobyty-pro-dva',
            position: 3,
            published_at: '2020-12-10T14:27:32.884Z',
            created_at: '2020-12-10T14:27:31.048Z',
            updated_at: '2020-12-13T12:31:02.780Z',
          },
          {
            id: 4,
            name: 'Víkendové pobyty',
            slug: 'vikendove-pobyty',
            position: 4,
            published_at: '2020-12-10T14:27:51.714Z',
            created_at: '2020-12-10T14:27:49.549Z',
            updated_at: '2020-12-13T12:32:49.383Z',
          },
        ],
      },
    ],
    properties: [],
    checkIn: { from: '14:30', to: '18:00' },
    checkOut: { from: '08:00', to: '10:00' },
    destinations: [
      {
        id: 1,
        name: 'Česko',
        slug: 'cesko',
        type: 'COUNTRY',
        parent: null,
        alias: 'Česko',
        combineName: 'v Česku',
        published_at: '2020-12-10T14:29:14.377Z',
        created_at: '2020-12-10T14:29:11.671Z',
        updated_at: '2020-12-13T11:26:47.208Z',
        cmsData: null,
      },
      {
        id: 6,
        name: 'Liberecký kraj',
        slug: 'liberecky-kraj',
        type: 'REGION',
        parent: 1,
        alias: 'Liberecký kraj',
        combineName: 'v Libereckém kraji',
        published_at: '2020-12-10T14:31:15.937Z',
        created_at: '2020-12-10T14:31:13.070Z',
        updated_at: '2020-12-13T11:26:47.181Z',
        cmsData: null,
      },
      {
        id: 7,
        name: 'Český ráj',
        slug: 'cesky-raj',
        type: 'REGION',
        parent: 6,
        alias: 'Český ráj',
        combineName: 'v Českém ráji',
        published_at: '2020-12-10T14:35:07.175Z',
        created_at: '2020-12-10T14:34:38.712Z',
        updated_at: '2020-12-13T13:25:28.407Z',
        cmsData: {
          id: 1,
          shortDescription:
            'Zastavte čas a věnujte se jen sobě. Zámecké pobyty, to je pohoda v krásném hotelu či penzionu s bazénem, odpočinek ve vířivce, sauně nebo pivní lázně. Nechte se opečovávat a lenošte během dovolené zcela bez výčitek. Zámecké pobyty se bude líbit vám, ale třeba i vašim rodičům.',
          longDescription:
            'Zastavte čas a věnujte se jen sobě. Zámecké pobyty, to je pohoda v krásném hotelu či penzionu s bazénem, odpočinek ve vířivce, sauně nebo pivní lázně. Nechte se opečovávat a lenošte během dovolené zcela bez výčitek. Zámecké pobyty se bude líbit vám, ale třeba i vašim rodičům.',
          image: null,
          images: [
            {
              id: 50,
              name: 'wellness.png',
              alternativeText: '',
              caption: '',
              width: 1326,
              height: 447,
              formats: {
                thumbnail: {
                  name: 'thumbnail_wellness.png',
                  hash: 'thumbnail_wellness_1c938c344c',
                  ext: '.png',
                  mime: 'image/png',
                  width: 245,
                  height: 83,
                  size: 53.75,
                  path: null,
                  url: '/uploads/thumbnail_wellness_1c938c344c.png',
                },
                large: {
                  name: 'large_wellness.png',
                  hash: 'large_wellness_1c938c344c',
                  ext: '.png',
                  mime: 'image/png',
                  width: 1000,
                  height: 337,
                  size: 765.42,
                  path: null,
                  url: '/uploads/large_wellness_1c938c344c.png',
                },
                medium: {
                  name: 'medium_wellness.png',
                  hash: 'medium_wellness_1c938c344c',
                  ext: '.png',
                  mime: 'image/png',
                  width: 750,
                  height: 253,
                  size: 442.45,
                  path: null,
                  url: '/uploads/medium_wellness_1c938c344c.png',
                },
                small: {
                  name: 'small_wellness.png',
                  hash: 'small_wellness_1c938c344c',
                  ext: '.png',
                  mime: 'image/png',
                  width: 500,
                  height: 169,
                  size: 204.02,
                  path: null,
                  url: '/uploads/small_wellness_1c938c344c.png',
                },
              },
              hash: 'wellness_1c938c344c',
              ext: '.png',
              mime: 'image/png',
              size: 1240.07,
              url: '/uploads/wellness_1c938c344c.png',
              previewUrl: null,
              provider: 'local',
              provider_metadata: null,
              created_at: '2020-12-11T11:44:01.732Z',
              updated_at: '2020-12-11T11:44:01.773Z',
            },
            {
              id: 8,
              name: '15000.jpg',
              alternativeText: '',
              caption: '',
              width: 939,
              height: 626,
              formats: {
                thumbnail: {
                  name: 'thumbnail_15000.jpg',
                  hash: 'thumbnail_15000_5ca34b8bfd',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 234,
                  height: 156,
                  size: 11.08,
                  path: null,
                  url: '/uploads/thumbnail_15000_5ca34b8bfd.jpg',
                },
                medium: {
                  name: 'medium_15000.jpg',
                  hash: 'medium_15000_5ca34b8bfd',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 500,
                  size: 96.34,
                  path: null,
                  url: '/uploads/medium_15000_5ca34b8bfd.jpg',
                },
                small: {
                  name: 'small_15000.jpg',
                  hash: 'small_15000_5ca34b8bfd',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 333,
                  size: 46.21,
                  path: null,
                  url: '/uploads/small_15000_5ca34b8bfd.jpg',
                },
              },
              hash: '15000_5ca34b8bfd',
              ext: '.jpg',
              mime: 'image/jpeg',
              size: 137.7,
              url: '/uploads/15000_5ca34b8bfd.jpg',
              previewUrl: null,
              provider: 'local',
              provider_metadata: null,
              created_at: '2020-11-13T08:26:51.946Z',
              updated_at: '2020-11-13T08:26:51.977Z',
            },
            {
              id: 5,
              name: '13000.jpg',
              alternativeText: '',
              caption: '',
              width: 939,
              height: 626,
              formats: {
                thumbnail: {
                  name: 'thumbnail_13000.jpg',
                  hash: 'thumbnail_13000_fc88327964',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 234,
                  height: 156,
                  size: 9.62,
                  path: null,
                  url: '/uploads/thumbnail_13000_fc88327964.jpg',
                },
                medium: {
                  name: 'medium_13000.jpg',
                  hash: 'medium_13000_fc88327964',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 500,
                  size: 81.38,
                  path: null,
                  url: '/uploads/medium_13000_fc88327964.jpg',
                },
                small: {
                  name: 'small_13000.jpg',
                  hash: 'small_13000_fc88327964',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 333,
                  size: 38.45,
                  path: null,
                  url: '/uploads/small_13000_fc88327964.jpg',
                },
              },
              hash: '13000_fc88327964',
              ext: '.jpg',
              mime: 'image/jpeg',
              size: 122.27,
              url: '/uploads/13000_fc88327964.jpg',
              previewUrl: null,
              provider: 'local',
              provider_metadata: null,
              created_at: '2020-11-13T08:26:51.049Z',
              updated_at: '2020-11-13T08:26:51.087Z',
            },
            {
              id: 6,
              name: '14000.jpg',
              alternativeText: '',
              caption: '',
              width: 939,
              height: 626,
              formats: {
                thumbnail: {
                  name: 'thumbnail_14000.jpg',
                  hash: 'thumbnail_14000_9bf9df0a87',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 234,
                  height: 156,
                  size: 12.9,
                  path: null,
                  url: '/uploads/thumbnail_14000_9bf9df0a87.jpg',
                },
                medium: {
                  name: 'medium_14000.jpg',
                  hash: 'medium_14000_9bf9df0a87',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 750,
                  height: 500,
                  size: 111.51,
                  path: null,
                  url: '/uploads/medium_14000_9bf9df0a87.jpg',
                },
                small: {
                  name: 'small_14000.jpg',
                  hash: 'small_14000_9bf9df0a87',
                  ext: '.jpg',
                  mime: 'image/jpeg',
                  width: 500,
                  height: 333,
                  size: 53.82,
                  path: null,
                  url: '/uploads/small_14000_9bf9df0a87.jpg',
                },
              },
              hash: '14000_9bf9df0a87',
              ext: '.jpg',
              mime: 'image/jpeg',
              size: 146.83,
              url: '/uploads/14000_9bf9df0a87.jpg',
              previewUrl: null,
              provider: 'local',
              provider_metadata: null,
              created_at: '2020-11-13T08:26:51.265Z',
              updated_at: '2020-11-13T08:26:51.311Z',
            },
          ],
        },
      },
      {
        id: 8,
        name: 'Hrubá Skála',
        slug: 'hruba-skala',
        type: 'CITY',
        parent: 7,
        alias: 'Hrubá Skála',
        combineName: 'v Hrubé Skále',
        published_at: '2020-12-10T14:37:54.556Z',
        created_at: '2020-12-10T14:35:33.425Z',
        updated_at: '2020-12-13T13:25:28.335Z',
        cmsData: null,
      },
    ],
  },
  {
    id: 2,
    isActive:true,
    ownerId:1,
    name: 'EA Hotel Kraskov',
    category: '****',
    destination: 'Chrudim, Pardubický kraj',
    price: 6790,
    slug: 'ea-hotel-kraskov',
    published_at: '2020-11-13T08:53:23.576Z',
    created_at: '2020-11-13T08:42:36.972Z',
    updated_at: '2020-12-10T15:01:41.462Z',
    ratting: { cleanliness: 5, comfort: 4.5, staf: 4.6, facilities: 5, locality: 5, priceValue: 5, total: 4.9, numberOfRattings:6 },
    address: {
      street: 'Třemošnice-Starý Dvůr 47',
      city: 'Chrudim',
      postalCode: '538 43',
      longitude: 15.60969,
      latitude: 49.86903,
    },
    roomTypes:[
      {id:1, name:'Dvoulůžkový pokoj', numberOfPax:2,numberOfExtrabed:0,numberOfChildExtrabed:0},
      {id:2, name:'Dvoulůžkový pokoj s přistýlkou', numberOfPax:2,numberOfExtrabed:1,numberOfChildExtrabed:0},
      {id:3, name:'Rodinný pokoj', numberOfPax:4,numberOfExtrabed:0,numberOfChildExtrabed:0}
    ],
    cmsData: {
      id: 5,
      shortDescription:
        'Nenechte si ujít jedinečnou příležitost strávit dovolenou v báječném **EA Hotelu Kraskov******. Obklopeni nádhernou přírodou Železných hor u **Sečské přehrady** si dopřejte ničím nerušený odpočinek. Krásně zrekonstruovaný hotel byl nově otevřen - **neváhejte a buďte mezi prvními hotelovými hosty!**',
      longDescription: '...',
      images: [
        {
          id: 45,
          name: '15300-Hotel-Kraskov.jpg',
          alternativeText: '',
          caption: '',
          width: 939,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_15300-Hotel-Kraskov.jpg',
              hash: 'thumbnail_15300_Hotel_Kraskov_e095f01f29',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 6.97,
              path: null,
              url: '/uploads/thumbnail_15300_Hotel_Kraskov_e095f01f29.jpg',
            },
            medium: {
              name: 'medium_15300-Hotel-Kraskov.jpg',
              hash: 'medium_15300_Hotel_Kraskov_e095f01f29',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 500,
              size: 47.19,
              path: null,
              url: '/uploads/medium_15300_Hotel_Kraskov_e095f01f29.jpg',
            },
            small: {
              name: 'small_15300-Hotel-Kraskov.jpg',
              hash: 'small_15300_Hotel_Kraskov_e095f01f29',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 333,
              size: 23.95,
              path: null,
              url: '/uploads/small_15300_Hotel_Kraskov_e095f01f29.jpg',
            },
          },
          hash: '15300_Hotel_Kraskov_e095f01f29',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 70.42,
          url: '/uploads/15300_Hotel_Kraskov_e095f01f29.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-14T08:33:49.906Z',
          updated_at: '2020-11-14T08:33:49.943Z',
        },
        {
          id: 49,
          name: '10000.jpg',
          alternativeText: '',
          caption: '',
          width: 938,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_10000.jpg',
              hash: 'thumbnail_10000_44456739c3',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 11.72,
              path: null,
              url: '/uploads/thumbnail_10000_44456739c3.jpg',
            },
            medium: {
              name: 'medium_10000.jpg',
              hash: 'medium_10000_44456739c3',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 501,
              size: 102.47,
              path: null,
              url: '/uploads/medium_10000_44456739c3.jpg',
            },
            small: {
              name: 'small_10000.jpg',
              hash: 'small_10000_44456739c3',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 334,
              size: 48.98,
              path: null,
              url: '/uploads/small_10000_44456739c3.jpg',
            },
          },
          hash: '10000_44456739c3',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 144.82,
          url: '/uploads/10000_44456739c3.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-14T08:33:50.976Z',
          updated_at: '2020-11-14T08:33:50.997Z',
        },
        {
          id: 46,
          name: '15100-Hotel-Kraskov.jpg',
          alternativeText: '',
          caption: '',
          width: 939,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_15100-Hotel-Kraskov.jpg',
              hash: 'thumbnail_15100_Hotel_Kraskov_4171ea7e61',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 7.43,
              path: null,
              url: '/uploads/thumbnail_15100_Hotel_Kraskov_4171ea7e61.jpg',
            },
            medium: {
              name: 'medium_15100-Hotel-Kraskov.jpg',
              hash: 'medium_15100_Hotel_Kraskov_4171ea7e61',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 500,
              size: 59.84,
              path: null,
              url: '/uploads/medium_15100_Hotel_Kraskov_4171ea7e61.jpg',
            },
            small: {
              name: 'small_15100-Hotel-Kraskov.jpg',
              hash: 'small_15100_Hotel_Kraskov_4171ea7e61',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 333,
              size: 27.89,
              path: null,
              url: '/uploads/small_15100_Hotel_Kraskov_4171ea7e61.jpg',
            },
          },
          hash: '15100_Hotel_Kraskov_4171ea7e61',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 93.45,
          url: '/uploads/15100_Hotel_Kraskov_4171ea7e61.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-14T08:33:50.138Z',
          updated_at: '2020-11-14T08:33:50.188Z',
        },
        {
          id: 44,
          name: '16000.jpg',
          alternativeText: '',
          caption: '',
          width: 938,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_16000.jpg',
              hash: 'thumbnail_16000_ce4c8c7a3a',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 7.94,
              path: null,
              url: '/uploads/thumbnail_16000_ce4c8c7a3a.jpg',
            },
            medium: {
              name: 'medium_16000.jpg',
              hash: 'medium_16000_ce4c8c7a3a',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 501,
              size: 53.9,
              path: null,
              url: '/uploads/medium_16000_ce4c8c7a3a.jpg',
            },
            small: {
              name: 'small_16000.jpg',
              hash: 'small_16000_ce4c8c7a3a',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 334,
              size: 27.68,
              path: null,
              url: '/uploads/small_16000_ce4c8c7a3a.jpg',
            },
          },
          hash: '16000_ce4c8c7a3a',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 79.14,
          url: '/uploads/16000_ce4c8c7a3a.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-14T08:33:49.681Z',
          updated_at: '2020-11-14T08:33:49.715Z',
        },
        {
          id: 43,
          name: '17000.jpg',
          alternativeText: '',
          caption: '',
          width: 938,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_17000.jpg',
              hash: 'thumbnail_17000_57cd3fb407',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 7.04,
              path: null,
              url: '/uploads/thumbnail_17000_57cd3fb407.jpg',
            },
            medium: {
              name: 'medium_17000.jpg',
              hash: 'medium_17000_57cd3fb407',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 501,
              size: 46.67,
              path: null,
              url: '/uploads/medium_17000_57cd3fb407.jpg',
            },
            small: {
              name: 'small_17000.jpg',
              hash: 'small_17000_57cd3fb407',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 334,
              size: 23.71,
              path: null,
              url: '/uploads/small_17000_57cd3fb407.jpg',
            },
          },
          hash: '17000_57cd3fb407',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 68.65,
          url: '/uploads/17000_57cd3fb407.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-14T08:33:49.170Z',
          updated_at: '2020-11-14T08:33:49.240Z',
        },
        {
          id: 47,
          name: '15000.jpg',
          alternativeText: '',
          caption: '',
          width: 938,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_15000.jpg',
              hash: 'thumbnail_15000_d0a19ae89e',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 7.91,
              path: null,
              url: '/uploads/thumbnail_15000_d0a19ae89e.jpg',
            },
            medium: {
              name: 'medium_15000.jpg',
              hash: 'medium_15000_d0a19ae89e',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 501,
              size: 56.83,
              path: null,
              url: '/uploads/medium_15000_d0a19ae89e.jpg',
            },
            small: {
              name: 'small_15000.jpg',
              hash: 'small_15000_d0a19ae89e',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 334,
              size: 28.36,
              path: null,
              url: '/uploads/small_15000_d0a19ae89e.jpg',
            },
          },
          hash: '15000_d0a19ae89e',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 85.52,
          url: '/uploads/15000_d0a19ae89e.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-14T08:33:50.386Z',
          updated_at: '2020-11-14T08:33:50.417Z',
        },
        {
          id: 48,
          name: '11000.jpg',
          alternativeText: '',
          caption: '',
          width: 938,
          height: 626,
          formats: {
            thumbnail: {
              name: 'thumbnail_11000.jpg',
              hash: 'thumbnail_11000_3d83fef8df',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 7.55,
              path: null,
              url: '/uploads/thumbnail_11000_3d83fef8df.jpg',
            },
            medium: {
              name: 'medium_11000.jpg',
              hash: 'medium_11000_3d83fef8df',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 501,
              size: 52.1,
              path: null,
              url: '/uploads/medium_11000_3d83fef8df.jpg',
            },
            small: {
              name: 'small_11000.jpg',
              hash: 'small_11000_3d83fef8df',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 334,
              size: 26,
              path: null,
              url: '/uploads/small_11000_3d83fef8df.jpg',
            },
          },
          hash: '11000_3d83fef8df',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 78.64,
          url: '/uploads/11000_3d83fef8df.jpg',
          previewUrl: null,
          provider: 'local',
          provider_metadata: null,
          created_at: '2020-11-14T08:33:50.634Z',
          updated_at: '2020-11-14T08:33:50.690Z',
        },
      ],
    },
    packages: [
      {
        id: 3,
        name: 'Romantický pobyt na Kraskově pro dva',
        slug: 'romanticky-pobyt-na-kraskove-pro-dva',
        priceFrom: 6790,
        priceTo: 6790,
        minNumberOfPax: 2,
        minNumberOfDays: 3,
        minNumberOfNights: 2,
        maxNumberOfPax: 2,
        maxNumberOfDays: 3,
        maxNumberOfNights: 2,
        cmsData: {
          id: 1,
          image: {
            id: 49,
            name: '10000.jpg',
            alternativeText: '',
            caption: '',
            width: 938,
            height: 626,
            formats: {
              thumbnail: {
                name: 'thumbnail_10000.jpg',
                hash: 'thumbnail_10000_44456739c3',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 11.72,
                path: null,
                url: '/uploads/thumbnail_10000_44456739c3.jpg',
              },
              medium: {
                name: 'medium_10000.jpg',
                hash: 'medium_10000_44456739c3',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 501,
                size: 102.47,
                path: null,
                url: '/uploads/medium_10000_44456739c3.jpg',
              },
              small: {
                name: 'small_10000.jpg',
                hash: 'small_10000_44456739c3',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 334,
                size: 48.98,
                path: null,
                url: '/uploads/small_10000_44456739c3.jpg',
              },
            },
            hash: '10000_44456739c3',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 144.82,
            url: '/uploads/10000_44456739c3.jpg',
            previewUrl: null,
            provider: 'local',
            provider_metadata: null,
            created_at: '2020-11-14T08:33:50.976Z',
            updated_at: '2020-11-14T08:33:50.997Z',
          },
        },
        variants: [
          {
            id: 4,
            name: '3denní romantika',
            numberOfPax: 2,
            numberOfExtraBed: 0,
            numberOfFreeChild: 0,
            numberOfNights: 2,
            content:
              '<ul>\n                                                    <li>2x ubytování ve dvoulůžkovém pokoji </li>\n                                                    <li>2x snídaně  pro 2 osoby</li>\n                                                    <li>1x večeře 2 chody pro 2 osoby</li>\n                                                    <li>1x slavnostní večeře pro 2 osoby</li>\n                                                    <li>1x welcome drink  pro 2 osoby</li>\n                                                    <li>2x privátní vstup do wellness na 1 hod (sauna,  bazén) pro 2 osoby</li>\n                                                    <li>2x privátní vstup do wellness na 1 hod (vířivka) pro 2 osoby </li>\n                                                    <li>1x sklenka Prosseca do wellness pro 2 osoby</li>\n                                                    <li>1x karafa vody s citronem do wellness  (za pobyt)</li>\n                                                    <li>2x volný vstup do fitness centra pro 2 osoby</li>\n                                                    <li>2x parkování v ceně  (za pobyt) </li>\n                                                    <li>1x 20% sleva na masáže   (za pobyt)</li>\n                                                    <li>1x WIFI  (za pobyt) </li>\n                                            </ul>',
            note: 'Při příjezdu je účtován rekreační a ubytovací poplatek obci 5 Kč za osobu na den, děti do 18 let a držitelé průkazu ZTP bez poplatku obci.',
            description:
              'Pozvěte svou drahou polovičku na úžasný romantický pobyt. Ubytováni budete v krásném designovém pokoji, kde na vás čeká malé překvapení. Blahodárný odpočinek na Vás čeká v hotelovém wellness centru, které bude patřit jen vám a pak můžete pokračovat romantickou večeří při svíčkách. Podlehněte jedinečnému kouzlu společných chvil a přijeďte za romantikou do EA Hotelu Kraskov!',
            termValidityFrom: '2020-11-16',
            termValidityTo: '2021-04-15',
            priceFrom: 6790,
            priceTo: 6790,
          },
        ],
        categories: [
          {
            id: 1,
            name: 'Wellness pobyty',
            slug: 'wellness-pobyty',
            position: 1,
            published_at: '2020-12-10T14:26:35.659Z',
            created_at: '2020-12-10T14:26:33.470Z',
            updated_at: '2020-12-13T12:33:33.807Z',
          },
          {
            id: 3,
            name: 'Pobyty pro dva',
            slug: 'pobyty-pro-dva',
            position: 3,
            published_at: '2020-12-10T14:27:32.884Z',
            created_at: '2020-12-10T14:27:31.048Z',
            updated_at: '2020-12-13T12:31:02.780Z',
          },
          {
            id: 4,
            name: 'Víkendové pobyty',
            slug: 'vikendove-pobyty',
            position: 4,
            published_at: '2020-12-10T14:27:51.714Z',
            created_at: '2020-12-10T14:27:49.549Z',
            updated_at: '2020-12-13T12:32:49.383Z',
          },
        ],
      },
      {
        id: 4,
        name: 'Relaxace na Kraskově pro dva',
        slug: 'relaxace-na-kraskove-pro-dva',
        priceFrom: 6990,
        priceTo: null,
        minNumberOfPax: 2,
        minNumberOfDays: 3,
        minNumberOfNights: 2,
        maxNumberOfPax: 2,
        maxNumberOfDays: 3,
        maxNumberOfNights: 2,
        cmsData: {
          id: 2,
          image: {
            id: 45,
            name: '15300-Hotel-Kraskov.jpg',
            alternativeText: '',
            caption: '',
            width: 939,
            height: 626,
            formats: {
              thumbnail: {
                name: 'thumbnail_15300-Hotel-Kraskov.jpg',
                hash: 'thumbnail_15300_Hotel_Kraskov_e095f01f29',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 234,
                height: 156,
                size: 6.97,
                path: null,
                url: '/uploads/thumbnail_15300_Hotel_Kraskov_e095f01f29.jpg',
              },
              medium: {
                name: 'medium_15300-Hotel-Kraskov.jpg',
                hash: 'medium_15300_Hotel_Kraskov_e095f01f29',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 750,
                height: 500,
                size: 47.19,
                path: null,
                url: '/uploads/medium_15300_Hotel_Kraskov_e095f01f29.jpg',
              },
              small: {
                name: 'small_15300-Hotel-Kraskov.jpg',
                hash: 'small_15300_Hotel_Kraskov_e095f01f29',
                ext: '.jpg',
                mime: 'image/jpeg',
                width: 500,
                height: 333,
                size: 23.95,
                path: null,
                url: '/uploads/small_15300_Hotel_Kraskov_e095f01f29.jpg',
              },
            },
            hash: '15300_Hotel_Kraskov_e095f01f29',
            ext: '.jpg',
            mime: 'image/jpeg',
            size: 70.42,
            url: '/uploads/15300_Hotel_Kraskov_e095f01f29.jpg',
            previewUrl: null,
            provider: 'local',
            provider_metadata: null,
            created_at: '2020-11-14T08:33:49.906Z',
            updated_at: '2020-11-14T08:33:49.943Z',
          },
        },
        variants: [
          {
            id: 5,
            name: '3denní relaxace',
            numberOfPax: 2,
            numberOfExtraBed: 0,
            numberOfFreeChild: 0,
            numberOfNights: 2,
            content:
              '<ul>\n                                                    <li>2x ubytování ve dvoulůžkovém pokoji</li>\n                                                    <li>2x snídaně  pro 2 osoby</li>\n                                                    <li>2x večeře 2chody pro 2 osoby</li>\n                                                    <li>1x welcome drink  pro 2 osoby</li>\n                                                    <li>1x masáž zad  30 minut  pro 2 osoby</li>\n                                                    <li>2x neomezený vstup do hotelového wellness  (vířivka) pro 2 osoby </li>\n                                                    <li>2x neomezený vstup do hotelového wellness  (sauna, bazén) pro 2 osoby</li>\n                                                    <li>2x využití fitness centra pro 2 osoby </li>\n                                                    <li>2x parkování v ceně  (za pobyt) </li>\n                                                    <li>1x 20% sleva na masáže   (za pobyt)</li>\n                                            </ul>',
            note: 'Při příjezdu je účtován rekreační a ubytovací poplatek obci 5 Kč za osobu na den, děti do 18 let a držitelé průkazu ZTP bez poplatku obci.',
            description:
              'Chcete si dopřát skvělou relaxaci, doplnit energii a zbavit se stresu? Pak je pro vás tím pravým náš relaxační pobyt. Dostane se vám maximální péče masáži a návštěva hotelového wellness centra bude skvělou tečkou za tímto bezva pobytem.',
            termValidityFrom: '2020-11-16',
            termValidityTo: '2021-04-30',
            priceFrom: 6990,
            priceTo: 6990,
          },
        ],
        categories: [
          {
            id: 3,
            name: 'Pobyty pro dva',
            slug: 'pobyty-pro-dva',
            position: 3,
            published_at: '2020-12-10T14:27:32.884Z',
            created_at: '2020-12-10T14:27:31.048Z',
            updated_at: '2020-12-13T12:31:02.780Z',
          },
          {
            id: 1,
            name: 'Wellness pobyty',
            slug: 'wellness-pobyty',
            position: 1,
            published_at: '2020-12-10T14:26:35.659Z',
            created_at: '2020-12-10T14:26:33.470Z',
            updated_at: '2020-12-13T12:33:33.807Z',
          },
          {
            id: 5,
            name: 'Vánoční pobyty',
            slug: 'vanocni-pobyty',
            position: 5,
            published_at: '2020-12-10T14:28:28.799Z',
            created_at: '2020-12-10T14:28:26.094Z',
            updated_at: '2020-12-13T12:32:15.873Z',
          },
        ],
      },
    ],
    properties: [],
    checkIn: { from: '14:00', to: null },
    checkOut: { from: null, to: '10:30' },
    destinations: [
      {
        id: 1,
        name: 'Česko',
        slug: 'cesko',
        type: 'COUNTRY',
        parent: null,
        alias: 'Česko',
        combineName: 'v Česku',
        published_at: '2020-12-10T14:29:14.377Z',
        created_at: '2020-12-10T14:29:11.671Z',
        updated_at: '2020-12-13T11:26:47.208Z',
        cmsData: null,
      },
      {
        id: 9,
        name: 'Pardubický kraj',
        slug: 'pardubicky-kraj',
        type: 'REGION',
        parent: 1,
        alias: 'Pardubický kraj',
        combineName: 'v Pardubickém kraji',
        published_at: '2020-12-10T14:37:02.082Z',
        created_at: '2020-12-10T14:36:59.046Z',
        updated_at: '2020-12-13T11:26:47.181Z',
        cmsData: null,
      },
      {
        id: 10,
        name: 'Sečská přehrada',
        slug: 'secska-prehrada',
        type: 'CITY',
        parent: 9,
        alias: 'Sečská přehrada',
        combineName: 'u Sečské přehrady',
        published_at: '2020-12-10T14:39:35.506Z',
        created_at: '2020-12-10T14:39:31.410Z',
        updated_at: '2020-12-13T11:26:29.065Z',
        cmsData: null,
      },
      {
        id: 11,
        name: 'Chrudim',
        slug: 'chrudim',
        type: 'CITY',
        parent: 9,
        alias: 'Chrudim',
        combineName: 'v Chrudimi',
        published_at: '2020-12-10T14:40:14.134Z',
        created_at: '2020-12-10T14:39:51.945Z',
        updated_at: '2020-12-13T11:32:58.802Z',
        cmsData: null,
      },
    ],
  },
];

export default  hotels;
